import { lazyWithPreload } from '../../navigation';

export const AgentsScreen = lazyWithPreload(() => import('./AgentsScreen.lazy'));
